// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card {\n  width: 320px;\n  margin: auto;\n}\n\n.discord-modal-text {\n  width: 80%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
